import { MAIN_DOMAIN, WEB_SERVER_HOST } from "@/environment/index";
import { createEcho } from "@/plugins/echo";
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import moment from "moment";
import * as axios from "@/services/Axios";
import {
  _asCardPayment,
  _asCashPayment,
  _getReceipt
} from "@/services/Payment";
import { _editBooking } from "@/services/Booking";
import { _recordAnalytics } from "@/services/analytics";
import { markPromotionPaymentExit } from "@/utils/promotionReload";

window.Echo = createEcho({
  host: WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
});

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export default {
  components: {
    Datepicker,
    vSelect
  },
  data() {
    return {
      vehicleOptions: [
        {
          label: 'Standard',
          id : -1
        },
        {
          label: '6 Seater',
          id : 1
        },
        {
          label: '8 Seater',
          id : 3
        }
      ],
      baseSeatingCapabilities: [],
      bookingCapabilities: [],
      selectedVehicleTypeId: null,
      nonBaseBookingCapabilities: [],

      bookingEditableFields:{
        date: { value: null, visible: true },
        time: { value: null, visible: true },
        pickup: { value: null, lat: null, lng:null, street: null, town: null, postCode: null, visible: true },
        dropOff: { value: null, lat: null, lng:null, street: null, town: null, postCode: null, visible: true },
        vehicleType: { value: null, visible: true },
        name: { value: null, visible: true },
        driverNotes: { value: null, visible: true }
      },
      editBookingPopup:false,
      current_company: null,
      charityDescriptionPopup: false,
      /** Revolut order public token from Merchant API (create order); used with Card pop-up. */
      revolutOrderToken: null,
      /** Hosted checkout URL returned by test-payment-processor. */
      checkoutUrl: null,
      /** Judo payment endpoint and reference. */
      postUrl: null,
      reference: null,
      /** Resolved method for current checkout: 'judo' | 'revolut'. */
      activePaymentMethod: null,

      amount: 0,
      pickup: "",
      destination: "",
      bid: null,
      booking_found: false,
      is_archived: false,
      checkezp: false,
      checkaccount: false,

      payment_type: null,

      pay_by_card_screen: true,
      variable_cost: false,
      pay_reference: "",

      is_dispatched: false,
      is_fixed_price: false,
      is_as_directed: false,
      amount_type: "Fixed",

      payment_done_case: false,

      bookingStatus: "",
      got_variable_price: false,
      is_locked: false,

      is_manual_booking: null,
      allow_manual_booking: null,
      allow_vehicle_type_change: true,
      manually_allowed_check: null,
      phonenumber: null,

      authcode: null,
      decryptedBookingId: null,
      bookingPickupTime: null,
      driverCallsign: null,

      ghostBooking: null,
      admin_allow_third_party: null,
      quoteData: null,
      booking_type: null,

      showCharityDiv: false,
      charityText: "",
      charityDescription: "",
      payForCharity: false,
      charityAmount: 0.0,
      newAmount: 0.0,
      beforeCharityAmount: 0,
      companyLogo: null,

      isAndroid: false,
      isIphone: false,
      isWindows: false,
      isMac:false,
      email: null,
      paidPaymentReference: null,
      bookingPaymentAmount: null,
      systemId: null,
      showTracking: false,
      showEditing: false,
      showVehicleType: false,
      disabledDates: {
        to: null
      },
      _editableDate:null,
      selectedVehicle: [],
      // selectedVehicle: null,
      payment_status: null,
      timeMin: null,
      company_number: null,
      provider: null,
      manuallyFixedPriceJob: false,
      accountBookingText: 'The following booking is on an invoiced account and cannot be changed into a non account booking',
      remoteCapabilities: null,
      isAirportBooking: false,
      
      // Airport booking service selection
      standardPrice: null,
      executivePrice: null,
      standardPayReference: '1234577',
      executivePayReference: '2242141',
      serviceOptions: [
        {
          id: 'standard',
          title: 'Standard Car',
          price: null, // Will be set from backend
          features: ['Normal vehicle', 'Professional chauffeur']
        },
        {
          id: 'executive',
          title: 'Executive Service',
          price: null, // Will be set from backend
          features: ['Premium vehicle', 'Professional chauffeur']
        }
      ],
      selectedServiceId: 'standard', // Default to standard service
      isProcessingAirportPayment: false, // Loading state for airport booking payment
    };
  },
  watch: {
    payForCharity(val) {
      // Skip charity prepaycall for airport bookings - they have separate payment flow
      if (this.isAirportBooking) {
        return;
      }
      
      if (val) {
        this.calculateAmountWithCharity();
        this.prepaycall(true);
      } else {
        this.amount = this.beforeCharityAmount;
        this.charityAmount = 0.0;
        this.prepaycall();
      }
    },
    'bookingEditableFields.date.value': function () {
      this.updateTimeMin();
    }
  },
  computed: {
    /**
     * Get the selected service price for airport bookings
     * Returns the price based on selected service
     */
    selectedServicePrice() {
      if (!this.isAirportBooking) {
        return this.amount; // Use default amount for non-airport bookings
      }
      
      const selectedService = this.serviceOptions.find(s => s.id === this.selectedServiceId);
      if (selectedService && selectedService.price) {
        // Extract numeric value from price string (e.g., "£12.50" -> 12.50)
        const priceStr = String(selectedService.price).replace(/[£,]/g, '');
        return parseFloat(priceStr) || this.amount;
      }
      
      return this.amount;
    },
    
    /**
     * Get formatted price string for display
     */
    formattedSelectedPrice() {
      if (!this.isAirportBooking) {
        return `£${this.amount}`;
      }
      const selectedService = this.serviceOptions.find(s => s.id === this.selectedServiceId);
      return selectedService ? selectedService.price : `£${this.amount}`;
    },
    
    formattedRemoteCapabilities() {
      if (!this.remoteCapabilities) {
        return [];
      }

      // If it's already an array
      if (Array.isArray(this.remoteCapabilities)) {
        return this.remoteCapabilities.map(cap => ({
          label: cap.name,
          id: cap.id,
        }));
      }

      // If it's an object, convert to array
      if (typeof this.remoteCapabilities === 'object') {
        // If it's an object with array-like structure
        if (Array.isArray(this.remoteCapabilities.data)) {
          return this.remoteCapabilities.data.map(cap => ({
            label: cap.name,
            id: cap.id,
          }));
        }
        // Try to convert object keys/values to array
        return Object.entries(this.remoteCapabilities).map(([key, value]) => ({
          label: (value && value.name) || key,
          id: (value && value.id),
         }));
      }

      return [];
    },
    vehicleTypeOptions() {
      const fallbackVehicleOptions = this.normalizeCapabilityList(this.vehicleOptions);
      const seatingOptions = this.baseSeatingCapabilities.length
        ? this.baseSeatingCapabilities
        : fallbackVehicleOptions;

      const hasAnyVehicleOption = seatingOptions.some(
        option => Number(option.id) === -1 || (option.name || "").toLowerCase() === "any vehicle"
      );

      if (hasAnyVehicleOption) {
        return seatingOptions;
      }

      return [{ id: -1, name: "ANY Vehicle" }, ...seatingOptions];
    }
  },
  mounted() {
    document.title = "NUDG Web Application";
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href =  `${process.env.BASE_URL}nudgpay-favicon.ico`;
    }
    this.detectDevice();
    this.updateTimeMin();
  },
  props: {
    bookingData: {
      type: Object,
      required: true
    }
  },
  beforeMount() {
    document.documentElement.style.overflow = "hidden";
    // Loader is already shown by wrapper component
    // Ensure bid is set before we load booking/payment data
    this.bid = this.$route.params.bid;
    this.loadBookingData();
  },
  methods: {
    loadBookingData() {
      // Whenever we (re)load booking data, clear any stale
      // airport payment loading state so that the Pay Now
      // button doesn't stay stuck in a processing state
      // when coming back via browser back / navigation.
      this.isProcessingAirportPayment = false;
      this.resetPaymentState();

      // Use booking data passed from parent component instead of making API call
      const res = { data: { obj: this.bookingData } };
      
      this.decryptedBookingId = res.data.obj.decrypt_booking_id;
      this.current_company = res.data.obj.company_id;
      this.systemId = res.data.obj.system_id;
      this.provider = res.data.obj.booking_provider;
      this.checkezp = res.data.obj.checkezp;
      this.payment_status = res.data.obj.payment_status;
      this.remoteCapabilities = res.data.obj.capabilities.data;
      this.initializeVehicleTypeDisplay(res.data.obj);
      this.isAirportBooking = res.data.obj.is_airport_booking;
      if (this.checkezp || this.payment_status == 'paid') this.payment_done_case = true;
      
      if (this.checkezp && this.payment_status !== 'paid') {
        this.$vs.notify({
          title: "Alert",
          text: "This booking is an EZP booking and payment is not completed.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
      if (!this.checkezp && this.payment_status === 'paid') {
        this.$vs.notify({
          title: "Notice",
          text: "Booking payment marked as paid locally, but is not updated in Ghost system.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }

      this.setSystemSpecificFeatures();
      this.company_number = res.data.obj.company_number ? res.data.obj.company_number : '1159500500';
     
      this.listen();
      this.listenForAnyChange();
      this.companyLogo = res.data.obj.company_logo
        ? MAIN_DOMAIN + res.data.obj.company_logo
        : null;
      this.showCharityDiv = res.data.obj.is_charity_enable;
      this.booking_type = res.data.obj.booking.bookingType;
      this.admin_allow_third_party = res.data.obj.admin_allow_third_party;
      this.quoteData = res.data.obj.getquotedata;
      this.ghostBooking = res.data.obj.booking;

      this.setBookingEditableFields(this.ghostBooking);
      this.pickup = res.data.obj.pickup;
      this.destination = res.data.obj.destination;
      this.checkaccount = res.data.obj.checkaccount;

      // Autocab-specific initialization
      this.initializeProviderSpecificData(res.data.obj);

      this.paidPaymentReference = res.data.obj.payment;

      this.is_as_directed = res.data.obj.is_as_directed;
      this.is_dispatched = res.data.obj.is_dispatched;
      this.is_fixed_price = res.data.obj.is_fixed_price;
      this.amount = res.data.obj.price;
      this.is_archived = res.data.obj.is_archived;
      this.pay_reference = res.data.obj.payment_ref;
      this.bookingStatus = res.data.obj.booking_status;
      this.payment_type = res.data.obj.payment_type;

      this.booking_found = true;
      this.variable_cost = res.data.obj.variable_cost;
      this.is_locked = res.data.obj.is_locked;
      this.is_manual_booking = res.data.obj.is_manual_booking;
      this.allow_manual_booking = res.data.obj.allow_manual_booking;
      this.allow_vehicle_type_change = res.data.obj.allow_vehicle_type_change;
      this.phonenumber = res.data.obj.cust_ref;
      this.bookingPaymentAmount = res.data.obj.payment_amount;

      if (this.admin_allow_third_party) {
        if (
          (!this.checkezp &&
            this.is_fixed_price &&
            this.payment_type == "Card") ||
          this.payment_type == "Card" ||
          ((this.bookingStatus == "active" || this.bookingStatus == "booked" || this.bookingStatus == "offered") &&
            this.is_fixed_price)
        ) {
          if (!this.is_archived && this.is_locked && !this.is_fixed_price)
            this.prepaycall();
          else if (!this.is_archived && this.is_fixed_price) this.prepaycall();

          else if (!this.is_archived && (this.bookingStatus == 'booked' || this.bookingStatus == 'offered') && !this.payment_done_case ) {
            this.prepaycall();
          }
        }
      } else {
        if (!this.checkezp && !this.is_archived) this.prepaycall();
      }

      if (this.is_manual_booking) {
        this.manually_allowed_check = this.allow_manual_booking
          ? true
          : false;
      } else {
        this.manually_allowed_check = true;
      }

      this.authcode = res.data.obj.authcode;
      this.bookingPickupTime = res.data.obj.booking_pickup_due_time;
      this.driverCallsign = res.data.obj.driver_callsign;
      this.admin_allow_third_party = res.data.obj.admin_allow_third_party;
    
      this.charityText = res.data.obj.charity
        ? res.data.obj.charity.title
        : "";
      this.charityDescription = res.data.obj.charity
        ? res.data.obj.charity.description
        : "";

    this.setVehicleType(
      this.bookingCapabilities.length
        ? this.bookingCapabilities
        : (this.ghostBooking && this.ghostBooking.capabilities) || []
    )
     const today = new Date();
      today.setHours(0, 0, 0, 0);
      this.disabledDates.to = today;
      this.setFieldEditability();
      this.$vs.loading.close();
      this.$nextTick(() => {
        this.setPickupPlace(this.pickup);
        this.setDropoffPlace(this.destination);
      });
    },
    setSystemSpecificFeatures() {
      console.log(this.bookingData);
      
      const features = (this.bookingData && this.bookingData.features) || [];
      this.showTracking = features.includes('nudgpay_tracking');
      this.showEditing = features.includes('nudgpay_editing');
      this.showVehicleType = features.includes('nudgpay_vehicle_type');
    },
    getUkTimeString() {
      const now = new Date();
      const ukTimeString = now.toLocaleString('en-GB', { 
        timeZone: 'Europe/London',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      return ukTimeString;
    },
    updateTimeMin() {
      const nowUkStr = this.getUkTimeString();
      const selected = this.bookingEditableFields.date.value;
      
      if (!selected) {
        this.timeMin = nowUkStr;
        return;
      }
      
      const today = new Date();
      const selectedDate = new Date(selected);
      
      const isToday = today.getFullYear() === selectedDate.getFullYear() &&
                      today.getMonth() === selectedDate.getMonth() &&
                      today.getDate() === selectedDate.getDate();
      
      this.timeMin = isToday ? nowUkStr : null;
    },
    revolutCheckoutMode() {
      return process.env.VUE_APP_REVOLUT_MODE === "sandbox" ? "sandbox" : "prod";
    },
    resetPaymentState() {
      this.checkoutUrl = null;
      this.revolutOrderToken = null;
      this.postUrl = null;
      this.reference = null;
      this.activePaymentMethod = null;
    },
    normalizePaymentMethod(rawMethod) {
      if (!rawMethod) return null;
      const value = String(rawMethod).trim().toLowerCase();
      if (value.includes("revolut")) return "revolut";
      if (value.includes("judo")) return "judo";
      return null;
    },
 
    notifyUnsupportedPaymentMethod() {
      this.$vs.notify({
        title: "Payment method not supported",
        text: "Unable to start checkout. This booking must use either a Judo or Revolut payment method.",
        iconPack: "feather",
        icon: "icon-cross-circle",
        color: "danger",
      });
    },
    applyPaymentResponse(paymentResponse = {}) {
      this.resetPaymentState();
console.log(paymentResponse);

      const paymentMethod = paymentResponse.payment_method;
      const checkoutUrl = paymentResponse.paymentByLinkUrl || paymentResponse.checkout_url;
      const revolutToken = paymentResponse.token;
      const postUrl = paymentResponse.payByLinkUrl;
      const reference = paymentResponse.reference;

      if (paymentMethod === "revolut") {
        if (!checkoutUrl && !revolutToken) {
          this.notifyUnsupportedPaymentMethod();
          return false;
        }
        this.activePaymentMethod = "revolut";
        this.checkoutUrl = checkoutUrl;
        this.revolutOrderToken = revolutToken;
        return true;
      }

      if (paymentMethod === "judo") {
        const judoCheckoutUrl = postUrl || checkoutUrl;
        console.log(judoCheckoutUrl);
        
        if (!judoCheckoutUrl) {
          this.notifyUnsupportedPaymentMethod();
          return false;
        }
        this.activePaymentMethod = "judo";
        this.postUrl = judoCheckoutUrl;
        this.reference = reference;
        // Keep existing button visibility logic intact.
        this.checkoutUrl = judoCheckoutUrl;
        return true;
      }

      this.notifyUnsupportedPaymentMethod();
      return false;
    },
    submitJudoCheckout() {
      if (!this.postUrl) {
        this.notifyUnsupportedPaymentMethod();
        return;
      }

      markPromotionPaymentExit();

      const form = document.createElement("form");
      form.method = "POST";
      form.action = this.postUrl;
      form.style.display = "none";

      if (this.reference) {
        const referenceInput = document.createElement("input");
        referenceInput.type = "hidden";
        referenceInput.name = "Reference";
        referenceInput.value = this.reference;
        form.appendChild(referenceInput);
      }

      document.body.appendChild(form);
      form.submit();
    },

    async handleSubmit() {
      await this.$nextTick();

      try {
        await _recordAnalytics({
          booking_id: this.decryptedBookingId,
          button_type: "pay_now",
          system_id: this.systemId,
        });
      } catch (error) {
        console.error("Error tracking Pay Now button:", error);
      }

      try {
        if (this.activePaymentMethod === "revolut") {
          if (!this.checkoutUrl) {
            this.notifyUnsupportedPaymentMethod();
            return;
          }
          markPromotionPaymentExit();
          window.location.href = this.checkoutUrl;
          return;
        }

        if (this.activePaymentMethod === "judo") {
          this.submitJudoCheckout();
          return;
        }

        this.notifyUnsupportedPaymentMethod();

      } catch (error) {
        console.error("Checkout redirect error:", error);
        this.$vs.notify({
          title: "Checkout error",
          text:
            (error && error.message) ||
            "Could not start payment. Please try again.",
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
    },
    onInputChange(selectedDate){
      const date = new Date(selectedDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      this._editableDate = `${year}-${month}-${day}`;
      return this._editableDate;
    },
    reloadPage(){
       window.location.reload();
    },
    editBooking() {
      this.$vs.loading({ text: "Saving modifications...." });

      const apiPayload = Object.fromEntries(
        Object.entries(this.bookingEditableFields)
          .filter(([key]) => this.showVehicleType || key !== 'vehicleType')
          .map(([key, field]) => [key, field.value])
      );

      const editData = {
        ...apiPayload, 'systemId' : this.systemId,
        'pickupLat': this.bookingEditableFields.pickup.lat,
        'pickupLng': this.bookingEditableFields.pickup.lng,
        'pickupStreet': this.bookingEditableFields.pickup.street,
        'pickupTown': this.bookingEditableFields.pickup.town,
        'pickupPostCode': this.bookingEditableFields.pickup.postCode,
        'dropOffLat': this.bookingEditableFields.dropOff.lat,
        'dropOffLng': this.bookingEditableFields.dropOff.lng,
        'dropOffStreet': this.bookingEditableFields.dropOff.street,
        'dropOffTown': this.bookingEditableFields.dropOff.town,
        'dropOffPostCode': this.bookingEditableFields.dropOff.postCode,
        'bookingStatus' : this.bookingStatus,
        'payment_status': this.payment_status,
      };

      if (this.showVehicleType) {
        const selectedVehicleTypeId = Number(this.selectedVehicleTypeId);
        const chipCapabilityIds = Array.isArray(this.nonBaseBookingCapabilities)
          ? this.nonBaseBookingCapabilities
              .map(capability => Number(capability.id))
              .filter(id => !Number.isNaN(id) && id > 0)
          : [];
        const vehicleTypeArray = [
          ...new Set(
            [
              !Number.isNaN(selectedVehicleTypeId) && selectedVehicleTypeId > 0
                ? selectedVehicleTypeId
                : null,
              ...chipCapabilityIds,
            ].filter(id => id !== null)
          ),
        ];
        this.selectedVehicle = vehicleTypeArray;
        editData.vehicleType = vehicleTypeArray;
      }

      editData.date = this.onInputChange(editData.date);

      _editBooking(this.decryptedBookingId, editData).then(
      (res) => {
        if(!res.data.obj.status_changed) {
          this.editBookingPopup = false;
          this.$vs.loading.close();
          if (res.data.obj.refresh) {
            this.$vs.notify({ color: '#79E864', title: 'Modified Success', text: 'Booking has been modified. Reloading booking' })
            setTimeout(() => {
              this.reloadPage();
            }, 3000);
          }
          else {
            this.$vs.notify({ color: '#79E864', title: 'Modified Success', text: 'Booking has been modified' })
          }
        }
        else {
           this.editBookingPopup = false;
          this.$vs.loading.close();
            this.$vs.dialog({
              color: 'danger',
              title: 'Booking update response',
              text: 'Booking status mismatched. You need to refresh ',
              accept:this.reloadPage
            });
          }
      },
      (error) => {
        this.$vs.loading.close();
        console.log(error.response.data);
        this.$vs.notify({
          title: "Error",
          text: error.response.data.responseMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger",
        });
      }
      );
    },
    capitalizeFirst(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    setPickupPlace(val) {
      if (this.$refs.pickupAutocomplete && this.$refs.pickupAutocomplete.$refs && this.$refs.pickupAutocomplete.$refs.input) {
        this.$refs.pickupAutocomplete.$refs.input.value = val;
      }
    },
    setDropoffPlace(val) {
      if (this.$refs.dropoffAutocomplete && this.$refs.dropoffAutocomplete.$refs && this.$refs.dropoffAutocomplete.$refs.input) {
        this.$refs.dropoffAutocomplete.$refs.input.value = val;
      }
    },
    setFieldEditability() {
      if (!this.showEditing) {
        return;
      }
      if(this.payment_done_case || this.manuallyFixedPriceJob) {
        this.bookingEditableFields.date.visible = false;
        this.bookingEditableFields.time.visible = false;
        this.bookingEditableFields.pickup.visible = false;
        this.bookingEditableFields.dropOff.visible = false;
        this.bookingEditableFields.vehicleType.visible = false;
      }
      else {
        if(this.bookingStatus == 'archived' || this.bookingStatus == 'complete' || this.bookingStatus == 'completed' || this.bookingStatus == 'cancelled') {
          this.bookingEditableFields.date.visible = false;
          this.bookingEditableFields.time.visible = false;
          this.bookingEditableFields.pickup.visible = false;
          this.bookingEditableFields.dropOff.visible = false;
          this.bookingEditableFields.name.visible = false;
          this.bookingEditableFields.driverNotes.visible = false;
          this.bookingEditableFields.vehicleType.visible = false;
          this.editBookingPopup = false;
          this.showEditing = false;
        }
        else {
          if (this.bookingStatus == 'dispatched' || this.bookingStatus == 'arrived' || this.bookingStatus == 'pickedup') {
              this.bookingEditableFields.date.visible = false;
              this.bookingEditableFields.time.visible = false;
              this.bookingEditableFields.pickup.visible = false;
              this.bookingEditableFields.vehicleType.visible = false;
              // Autocab-specific logic for dropOff visibility
              this.setDropOffEditability();
          }
          else {
              this.bookingEditableFields.date.visible = true;
              this.bookingEditableFields.time.visible = true;
              this.bookingEditableFields.pickup.visible = true;
              this.bookingEditableFields.dropOff.visible = true;
              this.bookingEditableFields.vehicleType.visible = true;
            }
        }
      }
      if (this.bookingStatus == 'active' || !this.showVehicleType) {
        this.bookingEditableFields.vehicleType.visible = false;
      }
    },
    convertToDate(dateString) {
      const [day, month, year] = dateString.split('/');
      const formattedDateString = [year, month, day].join('-');
      return new Date(formattedDateString);
    },
    setBookingEditableFields(booking) {
      const utcTime = booking.pickupDueTimeUtc;
      const dateObj = new Date(utcTime);

      const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Europe/London',
      };

      const formattedTime = dateObj.toLocaleTimeString('en-GB', options);
      const formattedDate = dateObj.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'Europe/London',
      });

      this.bookingEditableFields.date.value = formattedDate;
      this.bookingEditableFields.time.value = formattedTime;
      this.bookingEditableFields.pickup.value = booking.pickup.address.text;
      this.bookingEditableFields.pickup.lat = booking.pickup.address.coordinate.latitude;
      this.bookingEditableFields.pickup.lng = booking.pickup.address.coordinate.longitude;
      this.bookingEditableFields.pickup.street = booking.pickup.address.street || null;
      this.bookingEditableFields.pickup.town = booking.pickup.address.town || null;
      this.bookingEditableFields.pickup.postCode = booking.pickup.address.postCode || null;
      this.bookingEditableFields.dropOff.value = booking.destination.address.text;
      this.bookingEditableFields.dropOff.lat = booking.destination.address.coordinate.latitude;
      this.bookingEditableFields.dropOff.lng = booking.destination.address.coordinate.longitude;
      this.bookingEditableFields.dropOff.street = booking.destination.address.street || null;
      this.bookingEditableFields.dropOff.town = booking.destination.address.town || null;
      this.bookingEditableFields.dropOff.postCode = booking.destination.address.postCode || null;
      this.bookingEditableFields.name.value = booking.name;
      this.bookingEditableFields.driverNotes.value = booking.driverNote;

      document.querySelectorAll('.pac-container').forEach((el) => {
        el.style.zIndex = '900000';
      });
    },
    normalizeCapabilityList(capabilities, fallbackSources = []) {
      if (!Array.isArray(capabilities) || capabilities.length === 0) {
        return [];
      }

      const fallbackList = (fallbackSources || []).filter(Boolean);
      const fallbackById = new Map(
        fallbackList
          .filter(item => item.id !== null && item.id !== undefined)
          .map(item => [Number(item.id), item.name || item.label || ""])
      );

      return capabilities
        .map(capability => {
          if (typeof capability === "number") {
            const capabilityId = Number(capability);
            return {
              id: capabilityId,
              name: fallbackById.get(capabilityId) || `Capability ${capabilityId}`,
            };
          }

          if (capability && typeof capability === "object") {
            const capabilityId = Number(capability.id);
            if (Number.isNaN(capabilityId)) {
              return null;
            }

            return {
              id: capabilityId,
              name:
                capability.name ||
                capability.label ||
                fallbackById.get(capabilityId) ||
                `Capability ${capabilityId}`,
            };
          }

          return null;
        })
        .filter(Boolean);
    },
    initializeVehicleTypeDisplay(bookingPayload = {}) {
      const fallbackCapabilities = [
        ...this.formattedRemoteCapabilities.map(cap => ({
          id: cap.id,
          name: cap.label,
        })),
        ...this.vehicleOptions.map(option => ({
          id: option.id,
          name: option.label,
        })),
      ];

      const normalizedBaseCapabilities = this.normalizeCapabilityList(
        bookingPayload.base_seating_capabilities,
        fallbackCapabilities
      );

      this.baseSeatingCapabilities =
        normalizedBaseCapabilities.length > 0
          ? normalizedBaseCapabilities
          : this.normalizeCapabilityList(this.formattedRemoteCapabilities, fallbackCapabilities);

      const rawBookingCapabilities =
        bookingPayload.booking_capabilities ||
        (this.ghostBooking && this.ghostBooking.capabilities) ||
        [];

      this.bookingCapabilities = this.normalizeCapabilityList(
        rawBookingCapabilities,
        [...this.baseSeatingCapabilities, ...fallbackCapabilities]
      );

      const baseCapabilityIds = new Set(
        this.baseSeatingCapabilities.map(cap => Number(cap.id))
      );

      const selectedBaseCapability = this.bookingCapabilities.find(cap =>
        baseCapabilityIds.has(Number(cap.id))
      );

      this.selectedVehicleTypeId = selectedBaseCapability
        ? Number(selectedBaseCapability.id)
        : -1;

      this.nonBaseBookingCapabilities = this.bookingCapabilities.filter(
        cap => !baseCapabilityIds.has(Number(cap.id))
      );
    },
    setVehicleType(capabilities) {
      // Keep legacy selectedVehicle shape while also setting UI dropdown/chips
      const normalizedCapabilities = this.normalizeCapabilityList(
        capabilities,
        [
          ...this.baseSeatingCapabilities,
          ...this.formattedRemoteCapabilities.map(cap => ({
            id: cap.id,
            name: cap.label,
          })),
        ]
      );

      this.selectedVehicle = normalizedCapabilities.map(cap => Number(cap.id));

      const baseCapabilityIds = new Set(
        this.baseSeatingCapabilities.map(cap => Number(cap.id))
      );
      const selectedBaseCapability = normalizedCapabilities.find(cap =>
        baseCapabilityIds.has(Number(cap.id))
      );

      this.selectedVehicleTypeId = selectedBaseCapability
        ? Number(selectedBaseCapability.id)
        : -1;
      this.nonBaseBookingCapabilities = normalizedCapabilities.filter(
        cap => !baseCapabilityIds.has(Number(cap.id))
      );
    },
    editClick() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'edit',
        'system_id' : this.systemId
        }).then(
        (res) => {
          this.editBookingPopup = true;
          this.$nextTick(() => {
            this.setFieldEditability();
          });
        });
    },
    callUs() {
      window.location.href = 'tel:+44' + this.company_number;
    },
    async redirectToDownloadPage() {
      try {
        await _recordAnalytics({
              'booking_id' : (this.decryptedBookingId).toString(),
              'button_type' : 'download',
              'system_id' : this.systemId
          }).then((res)=> {
            console.log(res);
          });
          if (this.isAndroid || this.isWindows) {
            const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.dggroup.nudg.user.app&hl=en_US';
            window.location.href = playStoreUrl;
          } else if (this.isIphone || this.isMac) {
            const appleStoreUrl = 'https://apps.apple.com/gb/app/nudg-fast-safe-taxi-booking/id1618819793';
            window.location.href = appleStoreUrl;
          } else {
            console.log('what type of device is this ??');
          }
        } catch (error) {
        }
    },
    redirectToLiveTrackingPage() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'tracking',
        'system_id' : this.systemId
      }).then(
      (res) => {
        this.$router.push({ name: 'LiveTracking' });
      });
    },
    logAnalytic(btnType) {
       _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : btnType,
        'system_id' : this.systemId
      }).then(
      (res) => {
        console.log(res)
      });
    },
    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        this.isAndroid = true;
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.isIphone = true;
      }

      if (/windows phone/i.test(userAgent) || /win/i.test(userAgent)) {
        this.isWindows = true;
      }

       if (/macintosh|mac os x/i.test(userAgent)) {
        this.isMac = true;
      }
    },
    payByCard() {
      // Airport bookings have separate payment flow - skip original prepaycall
      if (this.isAirportBooking) {
        return;
      }
      
      _asCardPayment({ bid: this.bid }).then(
        (res) => {
          if (res.data.obj.errorCode == "0") {
            if (this.is_fixed_price) {
              this.prepaycall();
            } else {
              if (this.is_locked) {
                this.prepaycall();
              }
            }
            this.payment_type = "Card";
          }
        },
        (error) => {
          if (
            error.response.data.errors.errorCode == "3" ||
            error.response.data.errors.errorCode == "4"
          ) {
            this.bookingStatus = "archived";
            this.is_archived = true;
          }
          console.log(error.response.data.errors.errorCode);
        }
      );
    },
    payCash() {
      _asCashPayment({ bid: this.bid }).then(() => {
        this.payment_type = "Cash";
      });
    },
    listenForAnyChange() {
     window.Echo.channel(`booking.${this.decryptedBookingId}`).listen(
        "GeneralBookingEvent",
          (e) => {
          console.log(e);
          if(e.request_payload.EventType == 'BookingModified') {
            if(e.change_type == 'cost_modified')
              window.location.reload();
          }
          else if(e.change_type == 'booking_status') {
            if (e.request_payload && 'BookingStatus' in e.request_payload) {
              this.bookingStatus = e.request_payload.BookingStatus;
              console.log('BookingStatus exists:', e.request_payload.BookingStatus);
              this.setFieldEditability();
              if(e.request_payload.BookingStatus == 'cancelled' || e.request_payload.BookingStatus == 'complete') {
                this.bookingStatus = 'archived';
                this.editBookingPopup = false;
                this.showEditing = false;
              }
            }
          }
        });
    },
    listen() {
      window.Echo.channel(`meter-shout-booking-${this.bid}`).listen(
        "TaxiMeterShout",
        (e) => {
          if (this.admin_allow_third_party) {
            if (e.message == "vehicleDispatchEvent") {
              this.is_dispatched = true;
              this.bookingStatus = "pickedup";
            } else if (e.message == "variableBooking") {
              this.is_dispatched = true;
              this.bookingStatus = "pickedup";
              this.amount = null;
              this.amount_type = "Variable";
            } else {
              this.amount_type = "Variable";
              this.amount = e.data;
            }
            // Skip prepaycall for airport bookings - they have separate payment flow
            if (!this.isAirportBooking && !this.is_locked && this.payment_type == "Card") {
              this.is_locked = true;
              this.prepaycall();
            }
          }
        }
      );
    },
    payNow() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'pay_now',
        'system_id' : this.systemId
      }).then(
        (res) => {
          this.$refs.pay.submit();
        });
    },
    prepaycall(charity = false) {
      // Airport bookings use separate prepaycallForAirportBooking - skip original workflow
      if (this.isAirportBooking) {
        return;
      }
      
      if(this.payment_done_case)
        return;
      if(this.checkaccount)
        return;
      if (this.admin_allow_third_party) {
        if (this.is_fixed_price) this.amount = this.amount;
        else this.amount = this.amount ? this.amount : 0.0;
      } else {
        if (!this.is_manual_booking) {
          this.amount = this.quoteData["outward"]["price"];
        }
      }
      if (charity) {
        this.amount = this.newAmount;
      }
      this.resetPaymentState();
      const data = {
        bid: this.bid,
        price: this.amount,
        charityAmount: Number(this.charityAmount),
        actualBookingPrice: this.amount - this.charityAmount,
        pickup: this.pickup,
        destination: this.destination,
        cust_reference: this.phonenumber
          ? this.phonenumber
          : Math.random().toString(36).substring(2, 7),
        pay_reference: this.pay_reference,
      };
      axios.post(`booking/pay`, data).then(
        (resp) => {
          this.applyPaymentResponse(resp.data || {});
        },
        (error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseMessage,
            text: error.response.data.errors.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        }
      );
    },
    calculateAmountWithCharity() {
      var newAmount;
      if (Number.isInteger(this.amount)) newAmount = this.amount + 1;
      else newAmount = Math.ceil(this.amount);
      this.charityAmount = parseFloat(newAmount - this.amount).toFixed(2);
      this.newAmount = newAmount;
      return parseFloat(newAmount - this.amount).toFixed(2);
    },
    openCharityDescription() {
      if (!this.payForCharity) this.calculateAmountWithCharity();
      this.charityDescriptionPopup = true;
    },
    getReciept() {
      if (!this.email) alert("Please enter valid email to get receipt");
      _getReceipt({ email: this.email }, this.paidPaymentReference).then(
        (res) => {
          alert('email has been sent to your given address');
          this.email ='';
          console.log(res);
        }
      );
    },
    // Autocab-specific methods
    initializeProviderSpecificData(bookingData) {
      // Extract standard and executive prices and pay references from backend for airport bookings
      if (bookingData) {
        // Try different possible property names from backend
        // this.standardPrice = bookingData.standardPrice;
        this.standardPrice = bookingData.price;
                           
        this.executivePrice = bookingData.executivePrice;
        // this.executivePrice = bookingData.price+20.00;
        
        // Extract pay references for airport bookings
        // Try different possible property names from backend
        this.standardPayReference = bookingData.payment_ref;

        // this.executivePayReference = bookingData.payment_ref+'_39';
        this.executivePayReference = bookingData.executivePayReference;
        
        // Update service options with prices from backend
        if (this.standardPrice !== null) {
          const standardService = this.serviceOptions.find(s => s.id === 'standard');
          if (standardService) {
            standardService.price = `£${parseFloat(this.standardPrice).toFixed(2)}`;
          }
        }
        
        if (this.executivePrice !== null) {
          const executiveService = this.serviceOptions.find(s => s.id === 'executive');
          if (executiveService) {
            executiveService.price = `£${parseFloat(this.executivePrice).toFixed(2)}`;
          }
        }
        
        // For airport bookings, set initial amount to selected service price
        if (this.isAirportBooking && this.selectedServiceId) {
          this.updateAmountForSelectedService();
          
          // Call prepay with default selected service price to get postUrl and reference
          const defaultService = this.serviceOptions.find(s => s.id === this.selectedServiceId);
          if (defaultService && defaultService.price) {
            const priceStr = String(defaultService.price).replace(/[£,]/g, '');
            const servicePrice = parseFloat(priceStr);
            if (!isNaN(servicePrice)) {
              // Use $nextTick to ensure component is fully initialized
              this.$nextTick(() => {
                this.prepaycallForAirportBooking(servicePrice);
              });
            }
          }
        }
      }
    },
    
    /**
     * Update amount based on selected service for airport bookings
     */
    updateAmountForSelectedService() {
      if (!this.isAirportBooking) return;
      
      const selectedService = this.serviceOptions.find(s => s.id === this.selectedServiceId);
      if (selectedService && selectedService.price) {
        const priceStr = String(selectedService.price).replace(/[£,]/g, '');
        const priceValue = parseFloat(priceStr);
        if (!isNaN(priceValue)) {
          this.amount = priceValue;
          // Update beforeCharityAmount if it exists
          if (this.beforeCharityAmount !== undefined) {
            this.beforeCharityAmount = priceValue;
          }
        }
      }
    },
    
    /**
     * Prepay call specifically for airport bookings with selected service amount
     * This is separate from the original prepaycall to handle airport booking payment flow
     */
    prepaycallForAirportBooking(servicePrice) {
      if (this.payment_done_case) return;
      if (this.checkaccount) return;
      
      // Set loading state
      this.isProcessingAirportPayment = true;
      this.resetPaymentState();
      
      // Use the provided service price or fallback to current amount
      const priceToUse = servicePrice || this.selectedServicePrice || this.amount;
      
      // Get the correct pay_reference based on selected service
      let payReferenceToUse = this.pay_reference; // Default fallback
      if (this.selectedServiceId === 'standard' && this.standardPayReference) {
        payReferenceToUse = this.standardPayReference;
      } else if (this.selectedServiceId === 'executive' && this.executivePayReference) {
        payReferenceToUse = this.executivePayReference;
      }

      
      
      const data = {
        bid: this.bid,
        price: priceToUse,
        charityAmount: Number(this.charityAmount || 0),
        actualBookingPrice: priceToUse - (this.charityAmount || 0),
        pickup: this.pickup,
        destination: this.destination,
        cust_reference: this.phonenumber
          ? this.phonenumber
          : Math.random().toString(36).substring(2, 7),
        pay_reference: payReferenceToUse,
      };
      
      axios.post(`booking/pay`, data).then(
        (resp) => {
          this.applyPaymentResponse(resp.data || {});
          this.isProcessingAirportPayment = false;
        },
        (error) => {
          this.$vs.loading.close();
          this.isProcessingAirportPayment = false;
          const errorTitle = (error.response && error.response.data && error.response.data.responseMessage) || 'Error';
          const errorText = (error.response && error.response.data && error.response.data.errors && error.response.data.errors.message) || 'Failed to process payment';
          this.$vs.notify({
            title: errorTitle,
            text: errorText,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        }
      );
    },
    
    /**
     * Handle service selection for airport bookings
     */
    handleServiceSelect(service) {
      this.selectedServiceId = service.id;
      
      // Update amount when service is selected for airport bookings
      if (this.isAirportBooking) {
        this.updateAmountForSelectedService();
        
        // Call prepay with the selected service price to get postUrl and reference
        const selectedService = this.serviceOptions.find(s => s.id === service.id);
        if (selectedService && selectedService.price) {
          const priceStr = String(selectedService.price).replace(/[£,]/g, '');
          const servicePrice = parseFloat(priceStr);
          if (!isNaN(servicePrice)) {
            this.prepaycallForAirportBooking(servicePrice);
          }
        }
      }
    },
    setDropOffEditability() {
      // Autocab uses default behavior - dropOff is always visible when pickup is not
      this.bookingEditableFields.dropOff.visible = false;
    },
    formatPlaceAddress(place) {
      // Autocab uses default formatted_address
      if (!place || !place.formatted_address) {
        return '';
      }
      return place.formatted_address;
    },
    normalizeAddressWords(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[.,]/g, ' ')
        .replace(/\bst\b/g, 'street')
        .replace(/\brd\b/g, 'road')
        .replace(/\bave\b/g, 'avenue')
        .replace(/\bln\b/g, 'lane')
        .split(/\s+/)
        .filter((word) => word && word.length > 1);
    },
    addressPartsHaveSimilarWords(left, right) {
      const leftWords = this.normalizeAddressWords(left);
      const rightWords = this.normalizeAddressWords(right);
      if (!leftWords.length || !rightWords.length) return false;
      return leftWords.some((word) => rightWords.includes(word));
    },
    extractAddressParts(place) {
      const components = (place && place.address_components) || [];
      const getComponent = (type) => {
        const match = components.find(component =>
          Array.isArray(component.types) && component.types.includes(type)
        );
        return match ? match.long_name : '';
      };

      const placeName = (place && place.name) || '';
      const streetNumber = getComponent('street_number');
      const route = getComponent('route');

      let street;
      // If place.name and route overlap (e.g. "2 Little Tennis St" vs "Little Tennis Street"),
      // keep only street_number + route to avoid duplicated street text.
      if (placeName && route && this.addressPartsHaveSimilarWords(placeName, route)) {
        street = [streetNumber, route].filter(Boolean).join(', ');
      } else {
        street = [placeName, streetNumber, route].filter(Boolean).join(', ');
      }
      street = street || placeName || route || streetNumber || '';

      const town =
        getComponent('postal_town') ||
        getComponent('locality') ||
        getComponent('administrative_area_level_2') ||
        '';
      const postCode = getComponent('postal_code') || '';

      return { street, town, postCode };
    },
    setPlace(place) {
      // Autocab uses default place setting (formatted_address)
      if (place.name =='Birmingham Airport')
      {
        this.bookingEditableFields.pickup.value = 'Birmingham Airport (BHX), Birmingham B26 3QJ, UK';
        this.bookingEditableFields.pickup.street = 'Birmingham Airport (BHX)';
        this.bookingEditableFields.pickup.town = 'Birmingham';
        this.bookingEditableFields.pickup.postCode = 'B26 3QJ';
      }
      else
      {
        this.bookingEditableFields.pickup.value = place.formatted_address;
        const { street, town, postCode } = this.extractAddressParts(place);
        this.bookingEditableFields.pickup.street = street;
        this.bookingEditableFields.pickup.town = town;
        this.bookingEditableFields.pickup.postCode = postCode;
      }

      this.bookingEditableFields.pickup.lat = place.geometry.location.lat();
      this.bookingEditableFields.pickup.lng = place.geometry.location.lng();
    },
    setPlace2(place) {
      // Autocab uses default place setting (formatted_address)
      if (place.name =='Birmingham Airport')
      {
        this.bookingEditableFields.dropOff.value = 'Birmingham Airport (BHX), Birmingham B26 3QJ, UK';
        this.bookingEditableFields.dropOff.street = 'Birmingham Airport (BHX)';
        this.bookingEditableFields.dropOff.town = 'Birmingham';
        this.bookingEditableFields.dropOff.postCode = 'B26 3QJ';
      }
      else
      {
        this.bookingEditableFields.dropOff.value = place.formatted_address;
        const { street, town, postCode } = this.extractAddressParts(place);
        this.bookingEditableFields.dropOff.street = street;
        this.bookingEditableFields.dropOff.town = town;
        this.bookingEditableFields.dropOff.postCode = postCode;
      }
      this.bookingEditableFields.dropOff.lat = place.geometry.location.lat();
      this.bookingEditableFields.dropOff.lng = place.geometry.location.lng();
    },
  }
};

